<template>
  <div>
    <kst-output print-mode field="VendorName" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="VendorAddress" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "./ReceivePrintDetailsCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>